import { DefaultEdgeOptions, MarkerType, Position } from "react-flow-renderer"
import { EdgeTypes } from "./views/edges/EdgeTypes"

export const snapGrid: [number, number] = [5, 5]
export const connectionLineStyle = { stroke: "#000", strokeDasharray: "4" }

export const defaultEdgeOptions: DefaultEdgeOptions = {
  type: EdgeTypes.Floating,
  markerEnd: { type: MarkerType.ArrowClosed, strokeWidth: 2 }
}

export const positionsMap = {
  [Position.Bottom]: Position.Left,
  [Position.Left]: Position.Top,
  [Position.Top]: Position.Right,
  [Position.Right]: Position.Bottom
}

export const opposingPositionsMap = {
  [Position.Bottom]: Position.Top,
  [Position.Top]: Position.Bottom,
  [Position.Left]: Position.Right,
  [Position.Right]: Position.Left
}
